//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import TextureCallToAction from '../vue/CallToAction.vue';

export default {
  data() {
      return {
        show: false,
      };
  },
  
  props: {
    ctas: {
      type: String,
    },
  },
  
  computed: {

  },
  
  watch: {

  },
  
  methods: {

  },
  
  components: {
    TextureCallToAction,
  },
  
  created() {
    
  },
  mounted() {
    
  },
};




// WEBPACK FOOTER //
// ./scripts/vue/CallToActionContainer.vue